<app-header></app-header>
<app-right-side></app-right-side>
<!-- Main Header Groups -->

<link
rel="stylesheet"
data-purpose="Layout StyleSheet"
title="Web Awesome"
href="/css/app-wa-86cd56275caec687041f80b17dc62e32.css?vsn=d"
>

<link
  rel="stylesheet"
  href="https://site-assets.fontawesome.com/releases/v5.15.4/css/all.css"
>
<div *ngIf="currentUser.success.user.user_type_id == '12' || currentUser.success.user.user_type_id == '13' || currentUser.success.user.user_type_id == '11'" >
    <div class="container" >
        <div class="row">
            <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <div class="ui-block responsive-flex">
                    <img src="assets/img/statistics-bottom.jpg" style="height: auto; width: 100%;" class="img-responsive img-fluid" alt="banner">
                    <div class="ui-bloc1k-title">
                        <div class="h1" style="text-align: center; color: #3e758f;">Football Families Statistics</div>
                    </div>
                </div>
                <div class="h1" style="text-align: center; color: #9e2626; font-weight: 500;"><i class="fad fa-exclamation-triangle"></i>&nbsp;You do not have permission to access this page.</div>
                <br>
                <a routerLink="/home" style="text-align: center;">
                    <div style="font-size: 17px; border: 3px solid #d8d8d8; background-color: #252525; color: white; border-radius: 10px; padding: 10px; width: 150px; margin: 0px auto;">
                        <i class="fad fa-home"></i>&nbsp;Back Home
                    </div>
                </a>
            </div>
        </div>
    </div>
</div>
<!-- ... end Main Header Groups -->
<div *ngIf="currentUser.success.user.id == 1 || currentUser.success.user.user_type_id == '1' || currentUser.success.user.user_type_id == '5'" >
    <div class="container">
        <div class="row">
            <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <div class="ui-block responsive-flex">
                    <img src="assets/img/statistics-bottom.jpg" style="height: auto; width: 100%;" class="img-responsive img-fluid" alt="banner">
                    <div class="ui-bloc1k-title">
                        <div class="h1" style="text-align: center; color:#3e758f">Football Families Statistics</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
<br>
<div class="container">
    <div class="row">
        <div class="col col-xl-3 order-xl-2 col-lg-6 order-lg-1 col-md-6 col-sm-6 col-6">
            <div class="ui-block" style="background-color: #303030; text-align: center;">
                <div class="ui-block-content">
                    <ul class="statistics-list-count">
                        <li>
                            <div class="points">
                                <span style="font-size: 18px; color:white; text-align: center;">
									<span style="left: 35px; bottom: 40px; position:absolute; font-size: 50px;"><i class="fad fa-user-crown"></i></span>President
								</span>
                            </div>
                            <div *ngFor="let item of usertype1" class="count-stat" style="text-align: center;  font-size: 25px;">
                                <h3 style="color:white;">{{item.Count}}</h3>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="col col-xl-3 order-xl-2 col-lg-6 order-lg-1 col-md-6 col-sm-6 col-6">
            <div class="ui-block" style="background-color: #303030; text-align: center;">
                <div class="ui-block-content">
                    <ul class="statistics-list-count">
                        <li>
                            <div class="points">
                                <span style="font-size: 18px; color:white; text-align: center;">
									<span style="left: 35px; bottom: 40px; position:absolute; font-size: 50px;"><i class="fad fa-user-tie"></i></span>Executive Committee
								</span>
                            </div>
                            <div *ngFor="let item of usertype7" class="count-stat" style="text-align: center;  font-size: 25px;">
                                <h3 style="color:white;">{{item.Count}}</h3>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="col col-xl-3 order-xl-2 col-lg-6 order-lg-1 col-md-6 col-sm-6 col-6">
            <div class="ui-block" style="background-color: #303030; text-align: center;">
                <div class="ui-block-content">
                    <ul class="statistics-list-count">
                        <li>
                            <div class="points">
                                <span style="font-size: 18px; color:white; text-align: center;">
									<span style="left: 35px; bottom: 40px; position:absolute; font-size: 50px;"><i class="fad fa-user-shield"></i></span>Admins
								</span>
                            </div>
                            <div *ngFor="let item of usertype2" class="count-stat" style="text-align: center;  font-size: 25px;">
                                <h3 style="color:white;">{{item.Count}}</h3>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="col col-xl-3 order-xl-2 col-lg-6 order-lg-1 col-md-6 col-sm-6 col-6">
            <div class="ui-block" style="background-color: #303030; text-align: center;">
                <div class="ui-block-content">
                    <ul class="statistics-list-count">
                        <li>
                            <div class="points">
                                <span style="font-size: 18px; color:white; text-align: center;">
									<span style="left: 35px; bottom: 40px; position:absolute; font-size: 50px;"><i class="fad fa-users"></i></span>Members
								</span>
                            </div>
                            <div *ngFor="let item of usertype3" class="count-stat" style="text-align: center;  font-size: 25px;">
                                <h3 style="color:white;">{{item.Count}}</h3>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="col col-xl-3 order-xl-2 col-lg-6 order-lg-1 col-md-6 col-sm-6 col-6">
            <div class="ui-block" style="background-color: #9e2626; text-align: center;">
                <div class="ui-block-content">
                    <ul class="statistics-list-count">
                        <li>
                            <div class="points">
                                <span style="font-size: 18px; color:white; text-align: center;">
									<span style="left: 35px; bottom: 40px; position:absolute; font-size: 50px;"><i class="fad fa-user-chart"></i></span>Fans
								</span>
                            </div>
                            <div *ngFor="let item of usertype4" class="count-stat" style="text-align: center;  font-size: 25px;">
                                <h3 style="color:white;">{{item.Count}}</h3>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="col col-xl-3 order-xl-2 col-lg-6 order-lg-1 col-md-6 col-sm-6 col-6">
            <div class="ui-block" style="background-color: #0c8821; text-align: center;">
                <div class="ui-block-content">
                    <ul class="statistics-list-count">
                        <li>
                            <div class="points">
                                <span style="font-size: 18px; color:white; text-align: center;">
									<span style="left: 35px; bottom: 40px; position:absolute; font-size: 50px;"><i class="fad fa-futbol"></i></span>Players
								</span>
                            </div>
                            <div *ngFor="let item of usertype5" class="count-stat" style="text-align: center;  font-size: 25px;">
                                <h3 style="color:white;">{{item.Count}}</h3>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="col col-xl-3 order-xl-2 col-lg-6 order-lg-1 col-md-6 col-sm-6 col-6">
            <div class="ui-block" style="background-color: #ce8d02; text-align: center;">
                <div class="ui-block-content">
                    <ul class="statistics-list-count">
                        <li>
                            <div class="points">
                                <span style="font-size: 18px; color:white; text-align: center;">
									<span style="left: 35px; bottom: 40px; position:absolute; font-size: 50px;"><i class="fad fa-award"></i></span>Legends
								</span>
                            </div>
                            <div *ngFor="let item of usertype6" class="count-stat" style="text-align: center;  font-size: 25px;">
                                <h3 style="color:white;">{{item.Count}}</h3>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="col col-xl-3 order-xl-2 col-lg-6 order-lg-1 col-md-6 col-sm-6 col-6">
            <div class="ui-block" style="background-color: #3c78bd; text-align: center;">
                <div class="ui-block-content">
                    <ul class="statistics-list-count">
                        <li>
                            <div class="points">
                                <span style="font-size: 18px; color:white; text-align: center;">
									<span style="left: 35px; bottom: 40px; position:absolute; font-size: 50px;"><i class="fad fa-vote-yea"></i></span>Current Voting
								</span>
                            </div>
                            <div *ngFor="let item of CQAll" class="count-stat" style="text-align: center;  font-size: 25px;">
                                <h3 style="color:white;">{{item.CFAll}}</h3>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <hr>
</div>

<div class="container">
    <div class="row">
        <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="ui-block1">
                <div class="ui-block-title">
                    <div class="h6 title"><i class="fad fa-map-marked"></i>&nbsp;Fans Worldwide Statistics</div>
                </div>
                <div class="ui-block-content">
                    <div class="world-statistics">
                        <div class="row country-statistics">
                            <div  class="col-xl-12 col-lg-12 col-12">
                                <div  class="row">
                                    <div *ngFor="let item1 of fanscount" class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-4" style="border:1px solid #e7e7e7; padding: 5px;">
                                        <div class="row">
                                            <div class="col-xl-2 col-lg-4 col-4"><img src="assets/svg-icons/1x1/{{item1.code | lowercase}}.svg" alt="flags" style="width: 100%;"></div>
                                            <div class="col-xl-6 col-lg-4 col-4" style="font-size: 13px;">{{item1.countryName}}</div>
                                            <div class="col-xl-4 col-lg-4 col-4" style="font-size: 13px; text-align: center; font-weight: 600;">( {{item1.fanscount}} )</div>
                                        </div>
                            </div></div></div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <br><hr><br>
</div>

<div class="container">
    <div class="row">
        <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="ui-block1">
                <div class="ui-block-title">
                    <div class="h6 title"><i class="fad fa-newspaper"></i>&nbsp;Contents Statistics</div>
                </div>
                <br>
                <div class="ui-block-content">
                <div class="row">
                    <div class="col-lg-2">&nbsp;</div>
                    <div class="col-lg-2" style="background-color: #000000; text-align: center; border-radius: 10px;">
                        <ul class="statistics-list-count">
                            <li>
                                <div class="points">
                                    <span style="font-size: 18px; color:white; text-align: center;">
                                        <span style="left: 7px; bottom: 1px; position:absolute; font-size: 50px;"><i class="fad fa-newspaper"></i></span>Contents
                                    </span>
                                </div>
                                <div class="count-stat" style="text-align: center;  font-size: 25px;">
                                    <h3 style="color:white;">{{posts.length}}</h3>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="col-lg-1">&nbsp;</div>
                    <div class="col-lg-2" style="background-color: #e01b0d; text-align: center; border-radius: 10px;">
                        <ul class="statistics-list-count">
                            <li>
                                <div class="points">
                                    <span style="font-size: 18px; color:white; text-align: center;">
                                        <span style="left: 7px; bottom: 1px; position:absolute; font-size: 50px;"><i class="fad fa-thumbs-up"></i></span>Likes
                                    </span>
                                </div>
                                <div class="count-stat" style="text-align: center;  font-size: 25px;">
                                    <h3 style="color:white;">{{likestotal}}</h3>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="col-lg-1">&nbsp;</div>
                    <div class="col-lg-2" style="background-color: steelblue; text-align: center; border-radius: 10px;">
                        <ul class="statistics-list-count">
                            <li>
                                <div class="points">
                                    <span style="font-size: 18px; color:white; text-align: center;">
                                        <span style="left: 7px; bottom: 1px; position:absolute; font-size: 50px;"><i class="fad fa-comments"></i></span>Commants
                                    </span>
                                </div>
                                <div class="count-stat" style="text-align: center;  font-size: 25px;">
                                    <h3 style="color:white;">{{commtotal}}</h3>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div></div>
                <div class="ui-block-content container1">
                    <table class="table content1">
                        <tr style="font-size: 14px; background-color: #093952; color:#fff;">
                            <td>Content</td>
                            <td>Username</td>
                            <td>Likes</td>
                            <td>Commants</td>
                            <td>Last Update</td>
                        </tr>
                        <tr *ngFor="let itempost of posts" style="font-size: 12px; color:var(--text-color);">
                            <td>{{itempost.content}}</td>
                            <td>{{itempost.user.fullName}}</td>
                            <td>{{itempost.likesCounter}}&nbsp;<i class="fad fa-thumbs-up" style="color:#e01b0d"></i></td>
                            <td>{{itempost.commentsCounter}}&nbsp;<i class="fad fa-comments" style="color: steelblue;"></i></td>
                            <td><i class="fad fa-calendar-alt" style="color: #0c8821;"></i>&nbsp;{{itempost.updated_at | date:'dd/MM/yyyy - HH:mm:ss'}}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <br><hr><br>
</div>
